/* eslint-disable no-throw-literal */
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import clubAPI from "../api/clubAPI";
import userAPI from "../api/userAPI";
import "../App.scss";
import SubsidyOver from "../components/SubsidyOver";
import WebsiteViewer from "../components/WebsiteViewer";
import swalDialog from "../helpers/swalErrorPopup";
import WomanPilates from "../img/woman_sport.png";
import WOWVenue from "../img/WOWVenue.png";
import ClubAvailableNextMonthPopup from "../shared/ClubAvailableNextMonthPopup";
import LocationPopup from "../shared/locationPopup";
import PhoneDialog from "../shared/PhoneDialog";
import { PoweredBy } from "../shared/PoweredBy";
import RemainedCard from "../shared/remainedCard";
import { updateAllAppParams, updateAllClubParams } from "../store/appParamSlice";
import { isLoadChanger } from "../store/mainSlice";
import {
  activeMultipleEntryPassesDetailsSelector,
  hasActiveMultipleEntryPassSelector,
} from "../store/multipleEntryPassSlice";
import { isPartnerClalit, selectIsOrthodox, selectVenueData, setVenueData } from "../store/partnerStore";
import { updateIsHaveCreditCard } from "../store/userSlice";
import { getIsSubsidyOver } from "../utils/partner";

function Venue() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const hasActiveMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);
  const multipleEntryPassDetails = useSelector(activeMultipleEntryPassesDetailsSelector);

  const isClalit = useSelector(isPartnerClalit);
  const isOrthodox = useSelector(selectIsOrthodox);
  const venueData = useSelector(selectVenueData);
  const isSubsidyOver = getIsSubsidyOver();

  const [detailedClubParams, setDetailedClubParams] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedClub, setSelectedClub] = useState("");
  const [orderTimeRange, setOrderTimeRange] = useState([]);
  const [selectedClubCategory, setSelectedClubCategory] = useState("");
  const [btnText, setBtnText] = useState(t(""));
  const cityAndClubs = useSelector((state) => state.appParamSlice.allAppParams);
  const userParams = useSelector((state) => state.userSlice.userData);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const isHaveCreditCard = useSelector((state) => state.userSlice.isHaveCreditCard);

  const [selectedClubPhone, setSelectedClubPhone] = useState();
  const [open, setOpen] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [currentPrice, setCurrentPrice] = useState(location.state?.price);

  const { recordId } = useParams();
  const [data, setData] = useState({});

  const facebookLink = data?.IsImportantToNoteList?.find((item) => item.includes("https://m.facebook.com/"));
  const instagramLink = data?.IsImportantToNoteList?.find((item) => item.includes("www.instagram.com/"));
  const [openRemidedCard, setOpenRemidedCard] = useState(false);
  const [showWebsite, setShowWebsite] = useState(false);
  const [showClubAvailablePopup, setShowClubAvailablePopup] = useState(false);

  const chooseTextForBtn = (chosenClub) => {
    setSelectedClub(chosenClub);
    // Update current price when club is selected
    if (chosenClub?.Price) {
      setCurrentPrice(chosenClub.Price);
    }
    const isStudio = chosenClub?.IsStudio;
    const isRBox = chosenClub?.IsStudioRbox;
    const isStudioFizikal = chosenClub?.IsStudioFizikal;
    const isStudioLeap = chosenClub?.IsStudioLeap;
    const isStudioBoostapp = chosenClub?.IsStudioBoostapp;
    const isVenueClub = chosenClub?.IsVenueClub;
    const isClassSchedule = chosenClub?.IsClassSchedule;
    const isGeneralCondition = isRBox || isStudioFizikal || isStudioLeap || isStudioBoostapp;

    if ((isStudio || isClassSchedule) && isGeneralCondition) {
      setBtnText(t("VENUE_CHOOSE_CLASS"));
    } else if (isVenueClub && isGeneralCondition) {
      setBtnText(t("VENUE_BOOK"));
    } else if (isStudio) {
      setBtnText(t("VENUE_BOOK"));
    } else if (isRBox && isStudioFizikal) {
      setBtnText(t("VENUE_CHOOSE_CLASS"));
    } else if (isStudioFizikal || isStudioLeap || isStudioBoostapp) {
      setBtnText(t("VENUE_BOOK"));
    } else if (isRBox) {
      setBtnText(t("VENUE_CHOOSE_CLASS"));
    } else {
      setBtnText(t("VENUE_ENTER"));
    }
  };

  const handleChooseRightFlow = async () => {
    const chosenClub = cityAndClubs?.ClubList.find((el) => el.RecordID == recordId);
    setSelectedClub(chosenClub);
    if (isSubsidyOver && !isClalit && !chosenClub) {
      setShowClubAvailablePopup(true);
      return;
    }
    try {
      dispatch(isLoadChanger(true));
      const isStudio = chosenClub?.IsStudio;
      const isRBox = chosenClub?.IsStudioRbox;
      const isStudioFizikal = chosenClub?.IsStudioFizikal;
      const isStudioLeap = chosenClub?.IsStudioLeap;
      const isStudioBoostapp = chosenClub?.IsStudioBoostapp;
      const isVenueClub = chosenClub?.IsVenueClub;
      const isClassSchedule = chosenClub?.IsClassSchedule;
      const isGeneralCondition = isRBox || isStudioFizikal || isStudioLeap || isStudioBoostapp;
      setSelectedClubPhone(chosenClub.Phone);

      let isHaveCreditCard = await userAPI.isClientHaveCreditCard({
        token: mainUserParams.Token,
        id: mainUserParams.ID,
        phone: mainUserParams.Phone,
      });

      if (isHaveCreditCard.data.Error !== 0) {
        throw {
          code: isHaveCreditCard.data.Error,
          mess: isHaveCreditCard.data.Message,
        };
      }

      dispatch(updateIsHaveCreditCard(JSON.parse(isHaveCreditCard.data.Data).HasCreditCard));
      if (
        JSON.parse(isHaveCreditCard.data.Data).HasCreditCard ||
        (isClalit && hasActiveMultipleEntryPass && multipleEntryPassDetails.NumberOfEntries < 4)
      ) {
        if ((isStudio || isClassSchedule) && isGeneralCondition) {
          setBtnText(t("VENUE_CHOOSE_CLASS"));
          navigate("/selectRoomByDate", {
            state: {
              clubId: chosenClub.RecordID,
              clubName: chosenClub.Name,
              price: chosenClub.Price,
              type: "book",
            },
          });
        } else if (isVenueClub && isGeneralCondition) {
          setBtnText(t("VENUE_ENTER"));
          setOpen(true);
        } else if (isStudio) {
          setBtnText(t("VENUE_BOOK"));
          setOpen(true);
        } else if (isRBox && isStudioFizikal) {
          setBtnText(t("VENUE_CHOOSE_CLASS"));
          navigate("/selectRoomByDate", {
            state: {
              clubId: chosenClub.RecordID,
              clubName: chosenClub.Name,
              price: chosenClub.Price,
              type: "book",
            },
          });
        } else if (isStudioFizikal || isStudioLeap || isStudioBoostapp) {
          setBtnText(t("VENUE_BOOK"));
          setOpen(true);
        } else if (isRBox) {
          setBtnText(t("VENUE_CHOOSE_CLASS"));
          navigate("/selectRoomByDate", {
            state: {
              clubId: chosenClub.RecordID,
              clubName: chosenClub.Name,
              price: chosenClub.Price,
              type: "book",
            },
          });
        } else {
          setBtnText(t("VENUE_ENTER"));
          navigate("/summary", {
            state: {
              clubId: chosenClub.RecordID,
              clubName: chosenClub.Name,
              type: "checkin",
            },
          });
        }
      } else {
        navigate("/addCard", {
          state: {
            price: chosenClub.Price || currentPrice || location.state.price,
            clubId: recordId,
            clubName: data.Name,
            fromVenue: true,
          },
        });
      }
      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      swalDialog(err);
    }
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await clubAPI.getWebFullData({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
        });
        if (param.data.Error !== 0) {
          throw {
            code: param.data.Error,
            mess: param.data.Message,
          };
        }

        dispatch(updateAllAppParams(JSON.parse(param.data.Data)));
        const clubResp = await clubAPI.getClubCategoryList({
          binID: userParams.BinID,
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
          isFreefitWeb: true,
        });
        if (clubResp.data.Error !== 0) {
          dispatch(isLoadChanger(false));
          throw {
            code: clubResp.data.Error,
            mess: clubResp.data.Message,
          };
        }

        const clubParam = JSON.parse(param.data.Data);
        console.log(clubParam);

        dispatch(updateAllClubParams(JSON.parse(clubResp.data.Data)));
        setDetailedClubParams(clubParam?.ClubList);

        dispatch(updateAllAppParams(JSON.parse(param.data.Data)));
        if (!location.state.ignoreApiCall) {
          const res = await clubAPI.getDetailedClubInfoByID({
            clubID: recordId,
            token: mainUserParams.Token,
            id: mainUserParams.ID,
            phone: mainUserParams.Phone,
          });
          setData(JSON.parse(res.data.Data));
          dispatch(setVenueData(JSON.parse(res.data.Data)));
        } else {
          setData(venueData);
        }

        chooseTextForBtn(clubParam?.ClubList.find((el) => el.RecordID === Number(recordId)));
        dispatch(isLoadChanger(false));
      } catch (err) {
        swalDialog(err);
      }
    };
    if (userParams && Object.keys(userParams).length > 0) {
      fetch();
    }
  }, [userParams]);

  useEffect(() => {
    let clubs = cityAndClubs?.ClubList;
    if (selectedCity) {
      clubs = clubs.filter((el) => el.Address.includes(selectedCity));
    }
    if (selectedClub) {
      clubs = clubs.filter((el) => el.RecordID === selectedClub);
    }
    if (selectedClubCategory) {
      clubs = clubs.filter((el) => el.ClubTypeName === selectedClubCategory);
    }
    setDetailedClubParams(clubs);
  }, [selectedCity, selectedClub, selectedClubCategory]);

  const openMap = () => {
    navigate(`/map/${data.latitude}/${data.longitude}`);
  };

  useEffect(() => {
    if (selectedClub) {
      getOrderTimeRange();
    }
  }, [selectedClub]);

  const getOrderTimeRange = async () => {
    const orderTimeRange = await clubAPI.getOrderTimeRange({
      clubID: selectedClub.RecordID,
      token: mainUserParams.Token,
      id: mainUserParams.ID,
      phone: mainUserParams.Phone,
      isFreefitWeb: true,
    });
    if (orderTimeRange.data?.Data) {
      const dates = JSON.parse(orderTimeRange.data?.Data);
      const clearDates = dates.map((date) => moment.unix(date).format("DD/MM/YYYY"));
      setOrderTimeRange(clearDates);
    }
  };

  return (
    <div className="venue-container">
      <div className="venue-container-main">
        <div className="venue-img-container">
          {Object.keys(data).length === 0 ? (
            " "
          ) : isClalit ? (
            <img
              src={data.Images && data.Images.length > 0 && data.Images[0].Path ? data.Images[0].Path : WomanPilates}
              alt="Venue"
            />
          ) : (
            <img src={WOWVenue} alt="Venue" />
          )}
        </div>

        {Object.keys(data).length === 0 ? (
          ""
        ) : (
          <>
            <div className="venue-info-container">
              <div className="venue-location-container">
                {(currentPrice || location.state?.price) > 0 ? (
                  <div className="price">₪{currentPrice || location.state?.price}</div>
                ) : (
                  <div className="price"></div>
                )}
                <div className="venue-location-container-info">
                  <p className="venue-location-container-info-name">{data.Name}</p>
                  <span>
                    {t("CLUB_TYPE")}: {data.ClubTypeName}
                  </span>
                  <span>{data.Address}</span>
                </div>
              </div>
              {isSubsidyOver && !isClalit && <SubsidyOver />}
              <div className="venue-btns-container">
                <button
                  onClick={() => {
                    setShowWebsite(true);
                  }}
                >
                  {t("WEBSITE")}
                </button>
                <button>
                  <a href={`tel:${data.Phone.split("-").join("")}`}>{t("PHONE")}</a>
                </button>
                <button onClick={() => openMap()}>{t("NAVIGATION")}</button>
              </div>
            </div>

            <div className="venue-default-container">
              <p className="venue-default-header">{t("OPENING_HOURS")}</p>
              <span style={{ marginTop: "12px" }}>{data.OpeningHoursSundayToThursday}</span>
              <span>{data.OpeningHoursFriday}</span>
              <span>{data.OpeningHoursSaturday}</span>
            </div>

            <div className="venue-default-container">
              <p className="venue-default-header">{t("ABOUT_CLUB")}</p>
              <span style={{ marginTop: "5px", direction: "rtl" }}>{data.TextAbout}</span>
            </div>

            <div className="venue-default-container">
              <p className="venue-default-header">{t("IMPORTANT_NOTES")}</p>

              {data?.IsImportantToNoteList && (
                <>
                  <span style={{ direction: "rtl" }}>{data?.IsImportantToNoteList[0]}</span>
                  <span style={{ direction: "rtl" }}>{data?.IsImportantToNoteList[1]}</span>
                  <span style={{ direction: "rtl" }}>{data?.IsImportantToNoteList[2]}</span>
                  <span style={{ direction: "rtl" }}>{data?.IsImportantToNoteList[3]}</span>
                  <span style={{ direction: "rtl" }}>{data?.IsImportantToNoteList[4]}</span>
                  <span style={{ direction: "rtl" }}>{data?.IsImportantToNoteList[5]}</span>

                  {(facebookLink || instagramLink) && (
                    <div className="venue-link-container">
                      {facebookLink && (
                        <>
                          <span>{t("FACEBOOK_LINK")}:</span>
                          <br />
                          <a href={facebookLink} className="venue-link">
                            {facebookLink}
                          </a>
                        </>
                      )}

                      {instagramLink && (
                        <>
                          <span>{t("INSTAGRAM_LINK")}:</span>
                          <br />
                          <a href={instagramLink} className="venue-link">
                            {instagramLink}
                          </a>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}

              <div className="venue-contact-info-container-bottom">
                <div className="venue-contact-info">
                  <p className="contact-info-element">{data.Phone}</p>
                  <p className="venue-default-header">{t("PHONE")}</p>
                </div>

                <div className="venue-contact-info">
                  <p className="contact-info-element">{data.Parking ? t("EXISTS") : t("NO")}</p>
                  <p className="venue-default-header">{t("PARKING")}</p>
                </div>

                <div className="venue-contact-info">
                  <p className="contact-info-element">{data.InvalidParking ? t("EXISTS") : t("NO")}</p>
                  <p className="venue-default-header">{t("HANDICAP_PARKING")}</p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div
        style={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          backgroundColor: "var(--primary-color)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "58px",
          }}
          onClick={handleChooseRightFlow}
        >
          <p style={{ color: "#fff", fontWeight: 700 }}>{btnText}</p>
        </div>
        {isClalit && <PoweredBy full={true} />}
      </div>

      <RemainedCard isOpen={openRemidedCard} setIsOpen={setOpenRemidedCard} selectedClub={selectedClub} />

      <PhoneDialog
        isOpen={open}
        phone={selectedClubPhone}
        setIsOpen={setOpen}
        redirectToAnotherPage={() =>
          navigate("/selectDateTime", {
            state: {
              clubId: selectedClub.RecordID,
              clubName: selectedClub.Name,
              type: "invite",
              orderTimeRange: orderTimeRange,
            },
          })
        }
      />

      <LocationPopup
        isOpen={openLocation}
        setIsOpen={setOpenLocation}
        redirectToAnotherPage={
          isHaveCreditCard
            ? () =>
                navigate("/addCard", {
                  state: {
                    price: currentPrice || location.state.price,
                    clubId: recordId,
                    clubName: data.Name,
                    fromVenue: true,
                  },
                })
            : async () => {
                try {
                  const result = await clubAPI.webClubEntry({
                    token: mainUserParams.Token,
                    id: mainUserParams.ID,
                    phone: mainUserParams.Phone,
                    cardNumber: userParams.CardNumber,
                    source: isClalit ? null : (mainUserParams.Source ?? null),
                    terminalID: selectedClub.TerminalID,
                    clubID: selectedClub.RecordID,
                    entryCount: "1",
                    binType: selectedClub.BinType,
                    isOnlyCheckWithoutTransaction: false,
                  });
                  if (result.data.Error) {
                    throw {
                      code: result.data.Error,
                      mess: result.data.Message,
                    };
                  }
                  navigate("/orderConfirmation", {
                    state: {
                      date: moment().format("DD-MM-YYYY"),
                      hours: moment().format("HH"),
                      minutes: moment().format("mm"),
                      clubId: selectedClub.RecordID,
                      clubName: selectedClub.Name,
                    },
                  });
                } catch (err) {
                  dispatch(isLoadChanger(false));
                  swalDialog(err);
                }
              }
        }
        headerTextTop={t("CLUB_ENTRY_NOT_POSSIBLE")}
        headerTextBottom={t("CLUB_ENTRY_NOT_POSSIBLE_END")}
        bodyText={t("CLUB_ENTRY_NEARBY_ONLY")}
      />

      {showWebsite && <WebsiteViewer url={data.SiteUrl} onClose={() => setShowWebsite(false)} />}

      <ClubAvailableNextMonthPopup open={showClubAvailablePopup} onClose={() => setShowClubAvailablePopup(false)} />
    </div>
  );
}

export default Venue;
